import { AssetBalance } from '@/types/balances';
import { Market } from '@cex/shared-modules';
import { EntityId, EntityState } from '@reduxjs/toolkit';
import { sub } from 'date-fns';

enum TradingViewPeriod {
  Day = '1D',
  Week = '1W',
  Month = '1M',
  ThreeMonths = '3M',
  Year = '1Y',
  All = 'All'
}

const getStepDurationByPeriod = (resolution: TradingViewPeriod): Duration => {
  switch (resolution) {
    case TradingViewPeriod.Day:
      return { minutes: 30 };
    case TradingViewPeriod.Week:
      return { hours: 2 };
    case TradingViewPeriod.Month:
      return { hours: 8 };
    case TradingViewPeriod.ThreeMonths:
      return { days: 1 };
    case TradingViewPeriod.Year:
    case TradingViewPeriod.All:
      return { weeks: 1 };
  }
};

export const getCandlesTimeRanges = (to: Date, candlesAmount: number, period: TradingViewPeriod) => {
  const stepDuration = getStepDurationByPeriod(period);

  const timePoints: Date[] = [to];

  // +1 because we need candlesAmount ranges
  while (timePoints.length !== candlesAmount + 1) {
    const last = timePoints[timePoints.length - 1];

    timePoints.push(sub(last, stepDuration));
  }

  return timePoints.reverse();
};

export const getSelectedMarketFromUrl = (marketData: EntityState<Market | AssetBalance>) =>
  marketData?.ids?.find((market: EntityId) => {
    if (typeof market !== 'string') {
      return false;
    }
    return window.location.pathname.includes(market);
  });
